import React, { useContext, useEffect, useState } from "react";
import { fetchMemberTransactions, getMemberTransactions } from "../api/api"; // Updated API call
import { UserContext } from "../context/UserContext";
import HeaderQC from "./HeaderQC";

const QCPanelB = () => {
  const { user } = useContext(UserContext);
  const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // useEffect(() => {
  //   if (!user || !user.emailId) return; // Ensure user is available

  //   getMemberTransactions(user.emailId).then((data) => {
  //     if (!data) return; // Prevents undefined error
  //     setTransactions(data.filter((txn) => txn.problemReported));
  //   });
  // }, [user]); // Dependency to re-fetch if user

  useEffect(() => {
    const fetchData = async () => {
      if (!user) {
        console.warn("No user found, skipping fetch");
        return;
      }

      try {
        const data = await fetchMemberTransactions(user);

        if (data && Array.isArray(data)) {
          setTransactions(data);
        } else {
          console.error("Invalid data format:", data);
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
      }
    };

    fetchData();
  }, [user]);

  useEffect(() => {
    if (sessionStorage.getItem("refreshOnBack") === "true") {
      sessionStorage.removeItem("refreshOnBack");
      window.location.reload();
    }
  }, []);

  const handleEdit = (id) => {
    window.location.href = `/edit-transaction/${id}`;
  };

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    window.location.href = "/login";
  };

  const filteredTransactions = transactions.filter(
    (txn) =>
      txn.transaction_id?.toString().includes(searchTerm.trim()) ||
      txn.problem_comment?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-light">
      {/* Header */}
      <HeaderQC />

      {/* Main Content */}
      <div className="container-fluid py-4">
        <div className="card border-0 shadow-sm rounded-4">
          <div className="card-header bg-white border-0 py-3">
            <div className="row align-items-center">
              <div className="col">
                <h5 className="mb-0">Reported Issues: {transactions.length}</h5>
              </div>
              <div className="col-auto">
                <div className="input-group">
                  <span className="input-group-text border-0 bg-light">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-0 bg-light"
                    placeholder="Search transactions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="border-0 px-4">Transaction ID</th>
                    <th className="border-0">Team A remarks</th>
                    <th className="border-0 px-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTransactions.map((txn) => (
                    <tr key={txn.transaction_id}>
                      <td className="px-4">
                        <span className="fw-medium">{txn.transaction_id}</span>
                      </td>
                      <td>
                        <small className="text-muted">
                          {txn.team_a_remark || "No comment"}
                        </small>
                      </td>
                      <td className="px-4">
                        <button
                          className="btn btn-primary btn-sm rounded-pill px-3 fw-bold shadow-lg animate-hover"
                          onClick={() =>
                            handleEdit(txn.transaction_id, handleLogout)
                          }
                          style={{ transition: "0.3s", transform: "scale(1)" }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        >
                          <i className="bi bi-pencil-square me-2"></i>
                          Check
                        </button>
                      </td>
                      {/* <td>
                        <span
                          className={`badge rounded-pill px-3 ${
                            txn.status === "Complete"
                              ? "bg-success text-white"
                              : "bg-warning-subtle text-warning"
                          }`}
                        >
                          {txn.status}
                        </span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* No Issues Found */}
          {filteredTransactions.length === 0 && (
            <div className="text-center py-5">
              <i className="bi bi-inbox text-muted display-1"></i>
              <p className="mt-3 text-muted">No issues found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QCPanelB;
